import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { initialPublicationFilter } from "./FilterTypes/PublicationFilterType";


const PublicationFilter = () => {
  const title = RESX.SelectionManager.Publication;

  const options = serverReference.publicationStatuses;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("publication", {
    getTitle: () => title,
    renderSelection: (value) => <>{options.find(o => o.value === value.selectedPublication)?.text}</>,
    hasValue: (value) => value.selectedPublication != null,
    reset: () => initialPublicationFilter,
    areEqual: (a, b) => a.selectedPublication === b.selectedPublication
  });
  useEffect(() => {
    setInitialValue("publication", initialPublicationFilter);
  }, []);

  const [selectedPublication, setSelectedPublication] = React.useState<server.dto.PublicationStatus>(options.find(f => f.value === initialPublicationFilter.selectedPublication));

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onChange = (option: server.dto.PublicationStatus) => {
    let newSelectedOption: server.dto.PublicationStatus;
    if (option.value === selectedPublication?.value) { newSelectedOption = undefined; } else { newSelectedOption = option; }

    setSelectedPublication(newSelectedOption);
    setPopupOpen(false);
    setValue("publication", {
      selectedPublication: newSelectedOption?.value
    });
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedPublication(options.find(f => f.value === getValue("publication").selectedPublication));
    setPopupOpen(true);
  };

  const onApplyFilter = (e?) => {
    e?.preventDefault();
    setValue("publication", {
      selectedPublication: selectedPublication?.value
    });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      content={<form onSubmit={onApplyFilter}>
        <SelectableList
          noSearch
          selectedItems={selectedPublication != null ? [selectedPublication] : []}
          items={options}
          onItemToggled={onChange}
          getId={p => p.value}
          getName={b => b.text}
        />
      </form>}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default PublicationFilter;